import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { UpliftIndexTypePascalCaseEnum } from '@/graphql/contracts/_generated_/contracts';
import {
  GetUpliftIndexes,
  GetUpliftIndexesVariables
} from '@/graphql/contracts/_generated_/getUpliftIndexes.query';
import GetUpliftIndexesQuery from '@/graphql/contracts/getUpliftIndexes.query.gql';
import { notificationService } from '@/services/notification/notification.client';

interface UseGetUpliftIndexesProps {
  region: string;
  includeRates?: boolean;
  type?: UpliftIndexTypePascalCaseEnum;
}

export const useGetUpliftIndexes = () => {
  const [_getUpliftIndexes, { data, loading, error }] = useLazyQuery<
  GetUpliftIndexes,
  GetUpliftIndexesVariables
  >(GetUpliftIndexesQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) => notificationService.open({
      title: 'Error',
      text: err.message,
      type: 'danger'
    }),
  });

  const getUpliftIndexes = useCallback(async ({ region, includeRates = true, type }: UseGetUpliftIndexesProps) => {
    const response = await _getUpliftIndexes({
      variables: {
        region,
        includeRates,
        type,
      } as GetUpliftIndexesVariables,
    });
    return response.data?.getUpliftIndexes;
  }, [_getUpliftIndexes]);

  return {
    getUpliftIndexes,
    data,
    loading,
    error,
    indexes: data?.getUpliftIndexes || []
  } as const;
};
